import React, { useState, useEffect, useRef } from "react"
import { Col, Row, UncontrolledAlert, Spinner } from "reactstrap"
import api from "API/Api"
import { AvForm, AvField } from "availity-reactstrap-validation"
import { Link } from "react-router-dom"

const AddPlant = () => {
  const formRef = useRef(null)
  const [submitted, setSubmitted] = useState(false)
  const [loading, setLoading] = useState(false)
  const [states, setStates] = useState([])
  const [districts, setDistricts] = useState([])
  const [taluks, setTaluks] = useState([])
  const [companies, setCompanies] = useState([])
  const [loadingDistricts, setLoadingDistricts] = useState(false)
  const [loadingTaluks, setLoadingTaluks] = useState(false)

  useEffect(() => {
    const load = async () => {
      try {
        const [stResp, compResp] = await Promise.all([
          api.get("states"),
          api.get("companies")
        ])
        setStates(Array.isArray(stResp.data.data) ? stResp.data.data : stResp.data.data?.data || [])
        const compData = Array.isArray(compResp.data.data) ? compResp.data.data : compResp.data.data?.data || []
        setCompanies(compData)
      } catch (e) { console.error(e) }
    }
    load()
  }, [])

  const stateChangeHandler = async e => {
    const stateId = e.target.value
    setDistricts([]); setTaluks([])
    if (!stateId) return
    setLoadingDistricts(true)
    try {
      const resp = await api.get("districts/" + stateId)
      setDistricts(Array.isArray(resp.data.data) ? resp.data.data : resp.data.data?.data || [])
    } catch (e) { console.error(e) }
    setLoadingDistricts(false)
  }

  const districtChangeHandler = async e => {
    const districtId = e.target.value
    setTaluks([])
    if (!districtId) return
    setLoadingTaluks(true)
    try {
      const resp = await api.get("taluks/" + districtId)
      setTaluks(Array.isArray(resp.data.data) ? resp.data.data : resp.data.data?.data || [])
    } catch (e) { console.error(e) }
    setLoadingTaluks(false)
  }

  const handleValidSubmit = async (event, values) => {
    setLoading(true)
    try {
      // Auto-assign company if only one
      if (companies.length === 1) values.company_id = companies[0].id
      const response = await api.post("create-plant", values)
      if (response.data.success) {
        formRef.current.reset()
        setSubmitted(true)
        setDistricts([]); setTaluks([])
        setTimeout(() => setSubmitted(false), 4000)
      }
    } catch (error) {
      console.error(error)
      alert(error.response?.data?.message || "Failed to add plant")
    }
    setLoading(false)
  }

  return (
    <div className="dashBody">
      <div className="font-size-18 mb-0 dashHeader">
        <Row>
          <Col md={6}><h4>Add Plant</h4></Col>
          <Col md={6} style={{ textAlign: "right" }}>
            <Link to="/plants" className="dashBtn"><i className="fas fa-chevron-left"></i> <b>Back</b></Link>
          </Col>
        </Row>
      </div>
      <div className="dashContent">
        <AvForm ref={formRef} className="form-horizontal mt-4" onValidSubmit={handleValidSubmit}>

          {/* Plant Info */}
          <h6 style={{ color: "#6366f1", borderBottom: "2px solid #e2e8f0", paddingBottom: "8px", marginBottom: "16px" }}>
            <i className="fas fa-industry"></i> Plant Information
          </h6>
          <Row>
            {companies.length > 1 && (
              <Col md={4}><div className="mb-3">
                <AvField type="select" name="company_id" label="Company *" required>
                  <option value="">Select Company</option>
                  {companies.map((c, i) => <option key={i} value={String(c.id)}>{c.name}</option>)}
                </AvField>
              </div></Col>
            )}
            <Col md={companies.length > 1 ? 4 : 6}><div className="mb-3">
              <AvField name="name" label="Plant Name *" type="text" required placeholder="Enter Plant Name" />
            </div></Col>
            <Col md={companies.length > 1 ? 4 : 6}><div className="mb-3">
              <AvField name="number" label="Plant Number *" type="text" required placeholder="Enter Plant Number" />
            </div></Col>
          </Row>

          {/* Address: State → District → Taluk → Village → Door → Pincode */}
          <h6 style={{ color: "#0ea5e9", borderBottom: "2px solid #e2e8f0", paddingBottom: "8px", marginBottom: "16px", marginTop: "12px" }}>
            <i className="fas fa-map-marker-alt"></i> Address Details
          </h6>
          <Row>
            <Col md={4}><div className="mb-3">
              <AvField type="select" name="state" label="State *" required onChange={stateChangeHandler}>
                <option value="">Select State</option>
                {states.map((s, i) => <option key={i} value={String(s.id)}>{s.state}</option>)}
              </AvField>
            </div></Col>
            <Col md={4}><div className="mb-3">
              <AvField type="select" name="district" label={<>District * {loadingDistricts && <Spinner size="sm" color="primary" className="ms-1" />}</>} required onChange={districtChangeHandler}>
                <option value="">{loadingDistricts ? "Loading districts..." : districts.length ? "Select District" : "Select State first"}</option>
                {districts.map((d, i) => <option key={i} value={String(d.id)}>{d.district}</option>)}
              </AvField>
            </div></Col>
            <Col md={4}><div className="mb-3">
              <AvField type="select" name="taluk" label={<>Taluk * {loadingTaluks && <Spinner size="sm" color="primary" className="ms-1" />}</>} required>
                <option value="">{loadingTaluks ? "Loading taluks..." : taluks.length ? "Select Taluk" : "Select District first"}</option>
                {taluks.map((t, i) => <option key={i} value={t.taluk}>{t.taluk}</option>)}
              </AvField>
            </div></Col>
          </Row>
          <Row>
            <Col md={4}><div className="mb-3">
              <AvField name="village" label="Village *" type="text" required placeholder="Village Name" />
            </div></Col>
            <Col md={4}><div className="mb-3">
              <AvField name="door" label="Door No *" type="text" required placeholder="Door No" />
            </div></Col>
            <Col md={4}><div className="mb-3">
              <AvField name="pincode" label="Pin Code *" type="text" required placeholder="e.g. 388001"
                validate={{
                  required: { value: true, errorMessage: "Pin code is required" },
                  pattern: { value: /^[1-9][0-9]{5}$/, errorMessage: "Enter valid 6-digit pin code" },
                  minLength: { value: 6, errorMessage: "Pin code must be 6 digits" },
                  maxLength: { value: 6, errorMessage: "Pin code must be 6 digits" }
                }} />
            </div></Col>
          </Row>

          {/* Management */}
          <h6 style={{ color: "#22c55e", borderBottom: "2px solid #e2e8f0", paddingBottom: "8px", marginBottom: "16px", marginTop: "12px" }}>
            <i className="fas fa-user-tie"></i> Management
          </h6>
          <Row>
            <Col md={6}><div className="mb-3">
              <AvField name="plantManager" label="Plant Manager *" type="text" required placeholder="Enter Plant Manager Name" />
            </div></Col>
            <Col md={6}><div className="mb-3">
              <AvField name="productionManager" label="Production Manager *" type="text" required placeholder="Enter Production Manager Name" />
            </div></Col>
          </Row>

          <div className="mb-3 row mt-4">
            <div className="col-6">
              {submitted && <UncontrolledAlert color="success"><strong>Plant Added Successfully!</strong></UncontrolledAlert>}
            </div>
            <div className="col-6 text-end">
              <button className="btn btn-primary w-md waves-effect waves-light" type="submit" disabled={loading}>
                {loading ? <><Spinner size="sm" /><span style={{ paddingLeft: "10px" }}>Adding...</span></> : <span><i className="fas fa-plus-circle"></i> Add Plant</span>}
              </button>
            </div>
          </div>
        </AvForm>
      </div>
    </div>
  )
}

export default AddPlant
